var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAdditionFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F4F4F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0264 14.5207C17.2611 14.5207 14.2087 17.5731 14.2087 21.3384C14.2087 25.1037 17.2611 28.1561 21.0264 28.1561C24.7917 28.1561 27.8441 25.1037 27.8441 21.3384C27.8441 17.5731 24.7917 14.5207 21.0264 14.5207ZM12.2607 21.3384C12.2607 16.4973 16.1852 12.5728 21.0264 12.5728C25.8675 12.5728 29.792 16.4973 29.792 21.3384C29.792 23.4081 29.0747 25.3102 27.8751 26.8098L31.4546 30.3893C31.835 30.7696 31.835 31.3863 31.4546 31.7667C31.0743 32.147 30.4576 32.147 30.0773 31.7667L26.4978 28.1872C24.9982 29.3867 23.096 30.104 21.0264 30.104C16.1852 30.104 12.2607 26.1795 12.2607 21.3384Z",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9728,
    cy: 14.7384,
    r: 4.42588,
    fill: "#EF4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8533 12.618C25.9768 12.4945 26.177 12.4945 26.3004 12.618L27.9737 14.2913L29.6469 12.618C29.7704 12.4945 29.9706 12.4945 30.094 12.618C30.2175 12.7414 30.2175 12.9416 30.094 13.0651L28.4208 14.7383L30.094 16.4116C30.2175 16.5351 30.2175 16.7352 30.094 16.8587C29.9706 16.9821 29.7704 16.9821 29.6469 16.8587L27.9737 15.1854L26.3004 16.8587C26.177 16.9821 25.9768 16.9821 25.8533 16.8587C25.7299 16.7352 25.7299 16.5351 25.8533 16.4116L27.5266 14.7383L25.8533 13.0651C25.7299 12.9416 25.7299 12.7414 25.8533 12.618Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAdditionFound);
export default __webpack_public_path__ + "static/media/no-addition-found.c88f7a482d25dc629a9fd080af47e904.svg";
export { ForwardRef as ReactComponent };